import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { CrawlLinks } from './crawl_links'
import { tagsRepository } from '../repositories/tags_repository'
import {
  NamedItem,
  cardLinksFromItems,
  categoryPath,
  paginationLinks,
  readPage,
} from '../lib/internal_links'

type Props = Readonly<{
  tagId: number
}>

const SetCardIndex = ({ tagId }: Props) => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const page = readPage(location.search, 'cards_page')
  const [items, setItems] = useState<NamedItem[]>([])
  const [totalPages, setTotalPages] = useState(0)

  useEffect(() => {
    let cancelled = false

    tagsRepository
      .getItems(tagId, { page, types: [], limit: 48 })
      .then(({ items: nextItems, pagination }) => {
        if (cancelled) return
        setItems(nextItems as NamedItem[])
        setTotalPages(pagination.totalPages)
      })
      .catch(() => {
        if (cancelled) return
        setItems([])
        setTotalPages(0)
      })

    return () => {
      cancelled = true
    }
  }, [page, tagId])

  return (
    <CrawlLinks
      label={ t('links.cards') }
      heading={ t('links.cards') }
      links={ cardLinksFromItems(items, i18n.language, tagId) }
      pages={ paginationLinks(categoryPath(tagId), location.search, page, totalPages, 'cards_page') }
    />
  )
}

export { SetCardIndex }
